import { useState } from 'react';
import {
  Box,
  useTheme
} from '@mui/material';
import Sidebar, { DRAWER_WIDTH, COLLAPSED_DRAWER_WIDTH } from './Sidebar';
import { NOTES_PANEL_WIDTH } from '../common/NotesPanel';

interface AppLayoutProps {
  children: React.ReactNode;
  pageTitle?: string;
  pageActions?: React.ReactNode;
  header?: React.ReactNode;
  startDate?: string | null;
  endDate?: string | null;
}

const AppLayout = ({ children, pageTitle, pageActions, header, startDate, endDate }: AppLayoutProps) => {
  const theme = useTheme();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [isNotesOpen, setIsNotesOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleCollapseToggle = () => {
    setIsCollapsed(!isCollapsed);
  };
  
  const sidebarWidth = isNotesOpen ? NOTES_PANEL_WIDTH : (isCollapsed ? COLLAPSED_DRAWER_WIDTH : DRAWER_WIDTH);
  // TS type-check in this repo intermittently fails to pick up Sidebar prop updates.
  // Keep runtime props correct while staying non-invasive to existing Sidebar logic.
  const notesSidebarProps = {
    isNotesOpen,
    onNotesOpenChange: setIsNotesOpen,
    startDate: startDate || '',
    endDate: endDate || '',
  } as any;

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      {/* Sidebar (Includes Header and Drawer) */}
      <Sidebar
        onMenuClick={handleDrawerToggle}
        mobileOpen={mobileOpen}
        onDrawerToggle={handleDrawerToggle}
        pageTitle={pageTitle}
        pageActions={pageActions}
        isCollapsed={isCollapsed}
        onCollapseToggle={handleCollapseToggle}
        {...notesSidebarProps}
      />

      {/* Main content area */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          // Use md breakpoint to match Sidebar's behavior
          width: {
            xs: '100%',
            md: `calc(100% - ${sidebarWidth}px)`
          },
          background: '#f8fafc',
          minHeight: '100vh',
          transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
          }),
        }}
      >
        {/* Spacer for AppBar */}
        {/* <Toolbar /> */}

        {/* Sticky header (optional) */}
        {header}

        {children}
      </Box>
    </Box>
  );
};

export default AppLayout;
